import { createApp } from "vue";
import { store } from './store/store';
import ParkTrails from "./ParkTrails.vue";

declare global {
  interface Window {
    map: mapboxgl.Map;
    typesenseUrl: string;
    typesenseSearchApiKey: string;
    countryName: string;
    regionName: string;
    parkName: string;
  }
}


if (document.querySelector('#park_trails')) {
  const app = createApp(ParkTrails)
  app.use(store);
  app.mount("#park_trails");
}
